import React from 'react'
import { Col, Row } from 'antd'
import ChangePasswordCard from './ChangePasswordCard'
import SetupOtpCard from './SetupOtpCard'
import ResetOtpCard from './ResetOtpCard'
import ImpersonateCard from './ImpersonateCard'
import { UserTypes } from '../../../../constants/UserRoles'
import { UserRoles } from '../../../../constants'
import AuthorizedComponent from '../../../../components/authorization/AuthorizedComponent'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const SecuritySection = () => {
    useDocumentTitle('Security')

    return (
        <Row gutter={[24, 24]}>
            <Col span={8}>
                <ChangePasswordCard />
            </Col>
            <Col span={8}>
                <SetupOtpCard />
                <AuthorizedComponent roles={[UserRoles.ADMIN]} types={[UserTypes.SYSTEM_ADMIN]}>
                    <ResetOtpCard />
                </AuthorizedComponent>
            </Col>
            <Col span={8}>
                <AuthorizedComponent roles={[UserRoles.IMPERSONATOR]}>
                    <ImpersonateCard />
                </AuthorizedComponent>
            </Col>
        </Row>
    )
}

export default SecuritySection
